import React from "react";
import { Typography } from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import makeStyles from "@mui/styles/makeStyles";
import { Tooltip } from "../../components/Tooltip";
import FailedCourseTooltipContent from "../FailedCourseTooltipContent/FailedCourseTooltipContent";

const useTooltipStyles = makeStyles(theme => ({
  button: {
    marginLeft: theme.spacing(-2),
    "& svg": {
      paddingLeft: theme.spacing(1)
    }
  }
}));

const styles = theme => ({
  failedCourseScore: {
    fontWeight: "bold",
    color: theme.palette.error.main,
    "&:hover": {
      textDecoration: "underline"
    }
  }
});

const ScoreCell = props => {
  const {
    classes,
    passingScore,
    isSelfAssigned,
    isIlt,
    isActive,
    passedCompletionDate,
    scoreInfo
  } = props;

  const scoreClass =
    scoreInfo && scoreInfo.icon === "red" && classes.failedCourseScore;

  if (scoreClass) {
    return (
      <Tooltip
        title={
          <FailedCourseTooltipContent
            scoreInfo={scoreInfo}
            passingScore={passingScore}
            isSelfAssigned={isSelfAssigned}
            isIlt={isIlt}
            isActive={isActive}
            classes={useTooltipStyles()}
            passedCompletionDate={passedCompletionDate}
          />
        }
      >
        <Typography variant="body2" className={scoreClass}>
          {scoreInfo ? scoreInfo.label : "--"}
        </Typography>
      </Tooltip>
    );
  } else {
    return (
      <Typography variant="body2">
        {scoreInfo ? scoreInfo.label : "--"}
      </Typography>
    );
  }
};

export default withStyles(styles)(ScoreCell);
